<template>
    <router-view />
</template>

<script>
export default {
    name: 'MarketCharity',
};
</script>
